import React from "react";
import "./styles.sass";
import useHandler from "./handler";
import assets from "../../assets";

const AccountCreate = ({ noWrapper = false, onBack }) => {
  const {
    data,
    error,
    countries,
    states,
    cities,
    countryCodes,
    stepper,
    onChangeValue,
    onSubmit,
    navigate,
    setStepper,
    onValidate,
    isLoading
  } = useHandler();
  const {
    email,
    name,
    phone,
    city,
    age,
    country,
    state,
    username,
    dob,
    countryCode,
    address1,
    address2,
    address3,
    pincode,
  } = data;
  const {
    errEmail,
    errPhone,
    errName,
    errCity,
    errState,
    errCountry,
    errAge,
    errUsername,
    errDob,
    errCountryCode,
    errAddress1,
    errAddress2,
    errAddress3,
  } = error;

  return (
    <section className={noWrapper ? "account_create_inner" : "account_create"}>
      <section className="account_stepper">
        {[1, 2].map((item) => (
          <React.Fragment key={item}>
            <section className="account_step">
              <div
                className={`account_step_circle ${stepper === item ? "active" : ""}`}
              >
                {item}
              </div>

              <div className="account_step_content">
                <small>Step {item}</small>
                <h5>
                  {item === 1 ? "Personal Information" : "Address Details"}
                </h5>
              </div>
            </section>

            {item !== 2 && <div className="account_step_line"></div>}
          </React.Fragment>
        ))}
      </section>
      <section className="account_create_card">
        <h2>Create your account</h2>
        <p className="account_create_subheader">
          Fill in your details. It takes less than a minute.
        </p>

        {stepper === 1 && (
          <>
            <section className="account_create_row">
              <section className="acccount_form_group">
                <label>
                  Full Name <span className="account_star">*</span>
                </label>

                <input
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={name}
                  onChange={onChangeValue}
                />
                {errName && <p>{errName}</p>}
              </section>
              <section className="acccount_form_group">
                <label>
                  Username <span className="account_star">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter a username"
                  name="username"
                  value={username}
                  onChange={onChangeValue}
                />
                {errUsername && <p>{errUsername}</p>}
              </section>
            </section>
            <section className="account_create_row">
              <section className="acccount_form_group">
                <label>
                  Email <span className="account_star">*</span>
                </label>
                <input
                  type="email"
                  placeholder="hello@example.com"
                  name="email"
                  value={email}
                  onChange={onChangeValue}
                />
                {errEmail && <p>{errEmail}</p>}
              </section>
              <section className="acccount_form_group">
                <label>
                  DOB <span className="account_star">*</span>
                </label>
                <input
                  type="date"
                  placeholder="18"
                  name="dob"
                  value={dob}
                  onChange={onChangeValue}
                />
                {errDob && <p>{errDob}</p>}
              </section>
            </section>

            <section className="phone_acccount_form_group">
              <label>
                Phone Number <span className="account_star">*</span>
              </label>
              <section className="account_phone_input_wrapper">
                <select
                  name="countryCode"
                  value={countryCode}
                  onChange={onChangeValue}
                  className="account_country_code"
                >
                  {countryCodes?.map((item, index) => (
                    <option key={index} value={item?.code}>
                      {item?.country} ({item?.code})
                    </option>
                  ))}
                </select>
                {/* <section className="account_country_code_container">
                  <h4>india</h4>
                  <section className="account_country_container_list_wrapper">
                    <input placeholder="search country" name="searchCountry" />
                    <section>
                      {countryCodes?.map((item, index) => (
                        <h4 key={index} className="country_item">
                          {item?.country} ({item?.code})
                        </h4>
                      ))}
                    </section>
                  </section>
                </section> */}

                <section className="account_divider"></section>
                <input
                  type="text"
                  placeholder="Enter your phone number"
                  name="phone"
                  value={phone}
                  onChange={onChangeValue}
                />
              </section>
              {errPhone && <p>{errPhone}</p>}
            </section>
          </>
        )}

        {stepper === 2 && (
          <>
            <section className="acccount_form_group">
              <label>
                Address Line 1 <span className="account_star">*</span>
              </label>
              <input
                type="text"
                placeholder="Street address, P.O. box"
                name="address1"
                value={address1}
                onChange={onChangeValue}
              />
              {errAddress1 && <p>{errAddress1}</p>}
            </section>

            <section className="account_create_row">
              <section className="acccount_form_group">
                <label>
                  Address Line 2 <span className="account_star">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Apartment, suite, unit, building"
                  name="address2"
                  value={address2}
                  onChange={onChangeValue}
                />
                {errAddress2 && <p>{errAddress2}</p>}
              </section>

              <section className="acccount_form_group">
                <label>Address Line 3</label>
                <input
                  type="text"
                  placeholder="Landmark, area, locality"
                  name="address3"
                  value={address3}
                  onChange={onChangeValue}
                />
                {errAddress3 && <p>{errAddress3}</p>}
              </section>
            </section>

            <section className="account_create_row">
              <section className="acccount_form_group">
                <label>
                  Country <span className="account_star">*</span>
                </label>
                <select name="country" value={country} onChange={onChangeValue}>
                  <option value="" disabled>
                    Country
                  </option>
                  {countries?.map((item, index) => (
                    <option key={index}>{item}</option>
                  ))}
                </select>
                {errCountry && <p>{errCountry}</p>}
              </section>
              <section className="acccount_form_group">
                <label>
                  State <span className="account_star">*</span>
                </label>
                <input
                  type="text"
                  placeholder="State"
                  name="state"
                  value={state}
                  onChange={onChangeValue}
                />
                {errState && <p>{errState}</p>}
              </section>
            </section>

            {/* <section className="account_create_row"> */}
            {/* <section className="acccount_form_group">
            <label>State</label>
            <select name="state" value={state} onChange={onChangeValue}>
              <option value="" disabled>
                Select State
              </option>
              {states?.map(({ name }, index) => (
                <option key={index}>{name}</option>
              ))}
            </select>
            {errState && <p>{errState}</p>}
          </section> */}

            {/* </section> */}
            <section className="account_create_row">
              <section className="acccount_form_group">
                <label>
                  City <span className="account_star">*</span>
                </label>
                <input
                  type="text"
                  placeholder="City"
                  name="city"
                  value={city}
                  onChange={onChangeValue}
                />
                {errCity && <p>{errCity}</p>}
              </section>
              <section className="acccount_form_group">
                <label>Zipcode / Postal code</label>
                <input
                  type="text"
                  placeholder="e.g., 400001"
                  name="pincode"
                  value={pincode}
                  onChange={onChangeValue}
                />
                {/* {errP && <p>{errCity}</p>} */}
              </section>
            </section>
          </>
        )}

        <section className="account_create_btn_wrapper">
          <section
            className="account_create_back_btn"
            onClick={() => setStepper(1)}
          >
            <img src={assets.ic_left_arrow_blue} alt="ic_left_arrow_blue" />
            <h4>Back</h4>
          </section>
          <section
            className={`account_create_next_btn ${isLoading ? "disabled" : ""}`}
            onClick={() => {
              if (isLoading) return;

              if (stepper === 1) {
                const { isValid } = onValidate(1);

                if (!isValid) return;

                setStepper(2);
              } else {
                onSubmit();
              }
            }}
          >
            {/* <h4>{stepper === 2 ? "Submit" : "Next"}</h4> */}
            <h4>
              {isLoading ? "Submitting..." : stepper === 2 ? "Submit" : "Next"}
            </h4>
            {!isLoading && (
              <img src={assets.ic_right_arrow} alt="ic_right_arrow" />
            )}{" "}
          </section>
        </section>
        {/* <button type="submit" className="account_create_btn" onClick={onSubmit}>
          Create account
        </button> */}
      </section>
      <section className="login-text">
        Already have an account? <span onClick={onBack}>Log in</span>
      </section>
    </section>
  );
};

export default AccountCreate;
